import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  profile: {
    hotelName: '',
    roomNumber: '',
    guestName: '',
    checkInDate: null,
    checkOutDate: null,
  },
  preferences: {
    language: 'en',
    notifications: true,
  },
  currentLocation: null,
}

const guestSlice = createSlice({
  name: 'guest',
  initialState,
  reducers: {
    setGuestProfile: (state, action) => {
      state.profile = { ...state.profile, ...action.payload }
    },
    updatePreferences: (state, action) => {
      state.preferences = { ...state.preferences, ...action.payload }
    },
    setCurrentLocation: (state, action) => {
      state.currentLocation = action.payload
    },
    clearGuestData: (_state) => {
      return initialState
    },
  },
})

export const {
  setGuestProfile,
  updatePreferences,
  setCurrentLocation,
  clearGuestData,
} = guestSlice.actions

export default guestSlice.reducer

// Selectors
export const selectGuestProfile = (state) => state.guest.profile
export const selectGuestPreferences = (state) => state.guest.preferences